import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import SupervisorAccountRoundedIcon from "@material-ui/icons/SupervisorAccountRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import {
  Avatar,
  Collapse,
  Divider,
  TableHead,
  Typography,
} from "@material-ui/core";
import * as moment from "moment";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    [theme.breakpoints.down("md")]: {
      overflowX: "scroll",
    },
  },
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableHeader: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    color: "#212529",
    fontWeight: 600,
  },
  root: {
    padding: "10px 0%",
    [theme.breakpoints.down("md")]: {
      overflowX: "scroll",
    },
  },
  emptyDocDetails: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    color: "#277acc",
    minHeight: "7rem",
    position: "relative",
    top: "2.5rem",
  },
  mostWidth: {
    width: "400px !important",
  },
  moreWidth: {
    width: "300px !important",
  },

  objectFit: {
    objectFit: "contain",
  },
}));

const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

const InnerRow = (props) => {
  const [collapse, setCollapse] = useState(false);
  const classes = useStyles();

  const { item, mainIndex } = props;
  return (
    <TableRow>
      <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>
        <SupervisorAccountRoundedIcon />
      </TableCell>
      <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>
        <Typography
          style={{
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontWeight: "bold",
            color: "rgba(0,0,0,0.6)",
          }}
        >
          {item.message}
          {item?.filePath === null ? (
            ""
          ) : item?.fileType === "image" ? (
            <img
              style={{ width: "100px" }}
              src={ `${process.env.REACT_APP_DOC_URL}${item?.filePath}`}
              // src={`https://uat-nmp-api.startupindia.gov.in/v1/document/${item?.filePath}`}
            />
          ) : (
            <p>
              <a
                style={{ color: "#563A96",textDecoration: "underline", fontSize:'14px'}}
                src={ `${process.env.REACT_APP_DOC_URL}${item?.filePath}`}

                // href={`https://uat-nmp-api.startupindia.gov.in/v1/document/${item?.filePath}`}
                target="_blank"
              >
                Click to view pdf
              </a>
            </p>
          )}
        </Typography>

        <Typography
          style={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            float: "right",
            fontWeight: "bold",
            color: "rgba(0,0,0,0.6)",
          }}
        >
          Sent By: {item.senderName}
        </Typography>
        <br></br>
        <Typography
          style={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            float: "right",
            fontWeight: "bold",
            color: "rgba(0,0,0,0.6)",
          }}
        >
          {moment(item.timestamp).format("DD/MM/YYYY hh:mm A")}
        </Typography>
      </TableCell>
      <TableCell
        className={clsx(
          classes.tableRightBorder,
          classes.tableFont,
          classes.moreWidth
        )}
        style={{ padding: 0 }}
      >
        <Collapse in={collapse}>
          {item.participants?.map((p, index) => {
            return (
              <>
                <div
                  style={{
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    classes={{
                      img: classes.objectFit,
                    }}
                    src={p.image}
                  />
                  <Typography
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "rgba(0,0,0,0.6)",
                      marginLeft: "15px",
                    }}
                  >
                    {p.name}
                  </Typography>
                </div>
                <Divider
                  style={{ borderBottom: "2px solid rgba(0,0,0,0.4)" }}
                />
              </>
            );
          })}
        </Collapse>
        <Button
          variant="contained"
          onClick={() => setCollapse(!collapse)}
          style={{
            marginLeft: "10px",
            fontFamily: "Montserrat",
            fontWeight: "bold",
            color: "#fff",
            background: "#b499d7",
            marginBottom: collapse ? "10px" : "",
            marginTop: collapse ? "10px" : "",
          }}
        >
          <ExpandMoreRoundedIcon
            style={
              collapse
                ? { transform: "rotate(180deg)", color: "#fff" }
                : { color: "#fff" }
            }
          />{" "}
          {!collapse ? "SEE ALL RECIEPIENTS" : "HIDE ALL RECIEPIENTS"}
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function BasicTable(props) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell
                  className={clsx(
                    classes.tableRightBorder,
                    classes.tableHeader,
                    classes.lessWidth
                  )}
                >
                  NO.
                </TableCell> */}
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
                style={{ width: "40px" }}
              ></TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableHeader,
                  classes.mostWidth
                )}
              >
                MESSAGE
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableHeader,
                  classes.moreWidth
                )}
              >
                RECIEPIENTS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data?.map((item, index) => {
              return <InnerRow item={item} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
